import Mail from "@/assets/icons/Mail";
import Person from "@/assets/icons/Person";
import Phone from "@/assets/icons/Phone";
import Screen from "@/components/layout/Screen";
import AppButton from "@/components/shared/AppButton";
import { Card } from "@/components/shared/Card";
import PageTitle from "@/components/shared/PageTitle/PageTitle";
import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { Pressable } from "@/components/ui/pressable";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { useCustomTheme } from "@/hooks/useCustomTheme";
import { formatPhoneNumberForHelp } from "@/utils/formatPhoneNumber";
import { T, useT } from "@transifex/react";
import { openURL } from "expo-linking";
import { useState } from "react";
import { version } from "../../../package.json";

export default function Help() {
  const { skin } = useCustomTheme();
  const [showVersion, setShowVersion] = useState<boolean>(false);
  const t = useT();

  const renderOneButton = () => {
    if (skin.supportPhone) {
      return (
        <AppButton
          icon={Phone}
          iconPosition="before"
          onPress={() => {
            openURL(`tel:${skin.supportPhone}`);
          }}
          textClassName="font-bold"
          title={t("Call Us")}
          variant="primary"
        />
      );
    }
    if (skin.supportEmail) {
      return (
        <AppButton
          iconPosition="before"
          icon={Mail}
          onPress={() => {
            openURL(`mailto:${skin.supportEmail}`);
          }}
          textClassName="font-bold"
          title={t("Email Us")}
          variant="primary"
        />
      );
    }

    return <></>;
  };

  return (
    <Screen>
      <Pressable onPress={() => setShowVersion(!showVersion)}>
        <PageTitle title={t("Help")} />
      </Pressable>

      {showVersion && (
        <Text className="text-typography-900 text-center w-full">
          App Version: {version} ({process.env.EXPO_PUBLIC_BUILD_NUMBER})
        </Text>
      )}

      <VStack className="gap-[32px]">
        <Card className="py-[32px] px-[20px]">
          <HStack className="items-center gap-[16px]">
            <Person />
            <Box className="flex-1">
              <Text className="font-[400] leading-[20px] text-[14px] text-typography-900">
                <T _str="Seek out a parking attendant for assistance" />
              </Text>
            </Box>
          </HStack>

          {skin.supportEmail && (
            <HStack className="items-center gap-[16px]">
              <Mail />
              <Box className="flex-1">
                <Text className="font-[400] leading-[20px] text-[14px] text-typography-900">
                  <T
                    _str="Email {boldMail}"
                    boldMail={
                      <Pressable onPress={() => openURL(`mailto:${skin.supportEmail}`)} className="inline-block">
                        <Text className="font-[600] leading-[20px] text-[14px] text-typography-900 underline">{skin.supportEmail}</Text>
                      </Pressable>
                    }
                  />
                </Text>
              </Box>
            </HStack>
          )}

          {skin.supportPhone && (
            <HStack className="items-center gap-[16px]">
              <Phone />
              <Box className="flex-1">
                <Text className="font-[400] leading-[20px] text-[14px] text-typography-900">
                  <T
                    _str="For immediate assistance, please call {boldPhone}"
                    boldPhone={
                      <Pressable onPress={() => openURL(`tel:${skin.supportPhone}`)} className="inline-block">
                        <Text className="font-[600] leading-[20px] text-[14px] text-typography-900 underline">
                          {skin.supportPhone.includes("(") ? skin.supportPhone : formatPhoneNumberForHelp(skin.supportPhone)}
                        </Text>
                      </Pressable>
                    }
                  />
                </Text>
              </Box>
            </HStack>
          )}
        </Card>

        {renderOneButton()}
      </VStack>
    </Screen>
  );
}
